import Vue from 'vue'
import Router from 'vue-router'
import IsPC from '../assets/js/platform'
import PC from './pc'
import Mobile from './mobile'

Vue.use(Router)
let routes = [];

routes = routes.concat(PC);
routes = routes.concat(Mobile);

export default new Router({
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (IsPC) {
      return {x: 0, y: 0}
    }
    return {selector: 'scroller', offset: {x: 0, y: 0}}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js